import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem6xs12,
} from '../../../business-components/Grid/Grid'

import {
    ButtonIncluirLinha
 } from '../../../business-components/Button/Button'

import {
    incrementaContFamiliar,
} from '../cadastro-form/CadastroServiceFamiliares'

import {
    NomeFamiliar,
    IconButtonClearEntradaDadosFamiliar,
    NascimentoFamiliar,
    IdadeFamiliar,
    SexoFamiliar,
    ParentescoFamiliar,
    NomeCurtoFamiliar,
    CpfFamiliar,
    HerancaFamiliar,
} from '../cadastro-form/CadastroCompFamiliares'

import CadastroFormContaInvestimentos from '../cadastro-form/CadastroFormContaInvestimentos'



const FormFormFamiliares = ({ values, handleChange, handleSubmit, setFieldValue, linhaTipoLicenca, linhaFormList, jsonIntegracao }) => {

    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            
            <FieldArray name="familiares">
                {(arrayHelpers) => (
                    <DivForm>
                        <DivForm
                            style={{
                                display: values.familiares && values.familiares.length > 0 ? "block" : "none"
                            }}
                        >
                            <GridContainer>
                                {values.familiares?.map((item, ind) => (
                                    <GridItem6xs12
                                        key={ind}
                                    >
                                        <CardGridEntradaDados>
                                            <CardGridDivHeaderEntradaDados>
                                                <GridContainer>
                                                    <NomeFamiliar
                                                        item={item}
                                                        ind={ind}
                                                        handleChange={handleChange}
                                                    />
                                                    <IconButtonClearEntradaDadosFamiliar
                                                        values={values}
                                                        item={item}
                                                        ind={ind}
                                                        arrayHelpers={arrayHelpers}
                                                    />
                                                </GridContainer>
                                            </CardGridDivHeaderEntradaDados>

                                            <CardGridDivBodyEntradaDados>
                                                <GridContainer>
                                                    <NascimentoFamiliar
                                                        item={item}
                                                        ind={ind}
                                                        setFieldValue={setFieldValue}
                                                    />

                                                    <IdadeFamiliar
                                                        item={item}
                                                        ind={ind}
                                                        handleChange={handleChange}
                                                    />
                                                    
                                                    <SexoFamiliar
                                                        item={item}
                                                        ind={ind}
                                                        handleChange={handleChange}
                                                    />

                                                    <ParentescoFamiliar
                                                        item={item}
                                                        ind={ind}
                                                        handleChange={handleChange}
                                                    />
                                                </GridContainer>
                                                
                                                {(!jsonIntegracao || !jsonIntegracao.integracaoInclusaoSiteInstitucional2) && (
                                                    <>
                                                        <GridContainer>
                                                            {linhaFormList.informaNomeCurto === "S" && (
                                                                <NomeCurtoFamiliar
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                />
                                                            )}
                                                            {linhaFormList.informaCpf === "S" && (
                                                                <CpfFamiliar
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                />
                                                            )}
                                                        </GridContainer>

                                                        {linhaFormList.informaMeacao === "S" && (
                                                            <HerancaFamiliar
                                                                values={values}
                                                                item={item}
                                                                ind={ind}
                                                                handleChange={handleChange}
                                                            />
                                                        )}

                                                        {linhaFormList.informaContasInvestimentos === "S" &&
                                                        linhaTipoLicenca.exibirSomentePrevidenciaPrivada === 'N' && (
                                                            <>
                                                                <CardGridDividerElementos/>

                                                                <CadastroFormContaInvestimentos
                                                                    familiar={item.familiar}
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                />
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </CardGridDivBodyEntradaDados>
                                        </CardGridEntradaDados>
                                    </GridItem6xs12>
                                ))}
                            </GridContainer>
                        </DivForm>

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirFamiliar} 
                            onClick={() => 
                                {
                                    incrementaContFamiliar(values)
                                    arrayHelpers.push({
                                        familiar: values.contFamiliar,
                                        nascimentoFamiliar: null,
                                        parentescoFamiliar: HARDCODE.idParentescoFilhao
                                    })
                                }
                            }
                        /> 
                    </DivForm>
                )}
            </FieldArray>
        </ValidatorFormPadrao>
    )
}

export default FormFormFamiliares